export const convertMetresSquaredToHectares = (meters: number | undefined) => {
  //meters in m2
  if (meters) return (meters / 10000).toFixed(2);
};
